//Core
import React from "react"

//Components
import InputSimple from "../../InputSimple"
import OrderButton from "../../OrderButton"
import CheckBox from "../../CheckBox"

//UI
import Spinner from "../../UI/LightSpinner"
import { onSuccess, onFail } from "../../UI/PopUp"

//Hooks
import useForm from "../../../customHook/index"

//Style
import style from "./style.module.scss"

const { Container, FormWrapper, ButtonWrapper, Wrapper } = style

const classes = (...arg) => arg.join(" ")

const CreditForm = ({ link, product }) => {
  const {
    state,
    changeName,
    changePhone,
    checkedName,
    checkedPhone,
    toggleRule,
    onClick,
  } = useForm(link, product)
  const { name, phone, fetch, success, fail, rule } = state

  console.log("rule", rule)

  return fetch ? (
    <Spinner />
  ) : (
    <>
      <div id="form" className={classes(Container)}>
        <div className={Wrapper}>
          <form
            className={classes(FormWrapper)}
            onSubmit={e => {
              e.preventDefault()
              onClick()
            }}
          >
            <InputSimple
              change={changeName}
              message={"Перевірте правильність вводу імені"}
              checked={name.checked}
              placeholder={"Ім'я"}
              valid={name.valid}
              type="text"
              checkedFunc={checkedName}
              full={true}
            ></InputSimple>
            <InputSimple
              full={true}
              placeholder={"Телефон"}
              change={changePhone}
              checkedFunc={checkedPhone}
              checked={phone.checked}
              valid={phone.valid}
              message={
                "Перевірте правильність вводу номера мобільного телефону"
              }
              type="phone"
            ></InputSimple>
            <div className={ButtonWrapper}>
              <OrderButton click={onClick}>ВІДПРАВИТИ ЗАЯВКУ</OrderButton>
            </div>
          </form>
          <div style={{ justifySelf: "flex-start" }}>
            <CheckBox onClick={toggleRule} checked={rule}></CheckBox>
          </div>
        </div>
      </div>

      {success ? onSuccess() : null}
      {fail ? onFail() : null}
    </>
  )
}

export default CreditForm
